import React from 'react';
import { Spin } from 'antd';
import moment from 'moment';
import { STUDY_DATETIME_FORMAT } from '../../../../utils/helper';
import type { OrderDetails } from '../../types';

interface StudyQueueProps {
  orders: OrderDetails[];
  selectedIndex: number;
  loading: boolean;
  onSelect: (order: OrderDetails, index: number) => void;
}

/**
 * Compact studies queue rendered at the top of the reporting left rail.
 * Each row is a dense two-line entry: patient name + modality/desc + request time.
 */
const StudyQueue: React.FC<StudyQueueProps> = ({ orders, selectedIndex, loading, onSelect }) => (
  <Spin spinning={loading}>
    {orders.length === 0 ? (
      <div className="rail-empty">No studies</div>
    ) : (
      orders.map((order, idx) => {
        const po = order.pacs_order;
        return (
          <button
            type="button"
            key={po?.pacs_ord_id ?? idx}
            onClick={() => onSelect(order, idx)}
            className={`queue-item${selectedIndex === idx ? ' active' : ''}`}
          >
            <div className="queue-item-name" title={po?.patient?.pat_name}>
              {po?.patient?.pat_name}
            </div>
            <div className="queue-item-meta" title={`${po?.po_modality} | ${po?.po_diag_desc}`}>
              {po?.po_modality && <span className="queue-tag">{po.po_modality}</span>}
              <span className="queue-item-desc">{po?.po_diag_desc}</span>
            </div>
            <div className="queue-item-date">
              {moment(po?.po_req_time).format(STUDY_DATETIME_FORMAT)}
            </div>
          </button>
        );
      })
    )}
  </Spin>
);

export default StudyQueue;
